import { useMutation } from '@tanstack/react-query';
import { confirmDeliveredToConsumer } from '../services';

const useConfirmDeliveredToConsumer = () => {
  return useMutation({
    mutationKey: ['confirmDeliveredToConsumer'],
    mutationFn: async (payload) => await confirmDeliveredToConsumer(payload),
    retry: 3,
  });
};

export default useConfirmDeliveredToConsumer;
